import React from 'react'
import {SendFilesProps} from './types'
import SendFilesView from './SendFilesView'

const SendFiles = (props: SendFilesProps): React.ReactElement => <SendFilesView {...props} />

export default SendFiles
